import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "src/components/app/layout/Header";
import analytics from "src/helpers/analytics";
import { SCREEN_NAMES } from "src/helpers/analytics/events";

const LearnContentDetailsScreen: React.FC = () => {
  const location = useLocation();
  const { content } = location.state || {};
  const navigate = useNavigate();

  useEffect(() => {
    // Event: LEARN_CONTENT_DETAILS_SCREEN_LOADED
    analytics.pageView(SCREEN_NAMES.LEARN_CONTENT_DETAILS_SCREEN);
    window.scrollTo(0, 0);
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="relative pt-10 max-w-lg mx-auto">
      <div className="fixed top-0 left-0 right-0 z-10 max-w-lg mx-auto">
        <Header title={"Back"} onBackClick={handleBackClick} />
      </div>
      <div className="px-4 pt-5">
        <h1 className="text-2xl font-bold">{content?.title}</h1>
        <div className="flex items-center gap-2 mt-2">
          {content?.topic_name?.split(",")?.map((tag: string) => (
            <div
              key={tag}
              className="flex-shrink-0 text-xs font-medium text-[var(--app-primary)] text-center bg-[var(--icon-bg-primary)] border border-[var(--app-primary)] px-2 py-1 rounded-full"
            >
              {tag}
            </div>
          ))}
        </div>
        <div
          className="py-4"
          dangerouslySetInnerHTML={{ __html: content?.description }}
        />
      </div>
    </div>
  );
};

export default LearnContentDetailsScreen;
